import './DishFilter.scss';

const dishes = ["Biriyani", "Neychoru", "Pathiri", "Snacks", "Jeeraka Kanji ജീരക കഞ്ഞി", "Other"];

function DishFilter({ selectedDish, onDishChange }) {
  return (
    <div className="filter">
      <select
        value={selectedDish}
        onChange={(e) => onDishChange(e.target.value)}
        className="dish-filter-select"
      >
        <option value="">All Dishes</option>
        {dishes.map(dish => (
          <option key={dish} value={dish}>{dish}</option>
        ))}
      </select>
    </div>
  );
}

export default DishFilter;
